/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Oct 2021
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import styles from './Redeem.module.css';

const VoucherInput = props => {
  const { first4Digit, last4Digit, handleInputChange } = props;
  return (
    <div className={styles.inputWrapper}>
      <input
        type='text'
        maxLength={4}
        value={first4Digit}
        onChange={handleInputChange('first4Digit')}
        placeholder='First 4 digit'
        className={styles.input} />
      <span>***</span>
      <input
        type='text'
        maxLength={4}
        value={last4Digit}
        onChange={handleInputChange('last4Digit')}
        placeholder='Last 4 digit'
        className={styles.input} />
    </div>
  );
};

export default VoucherInput;

VoucherInput.propTypes = {
  first4Digit: PropTypes.string,
  last4Digit: PropTypes.string,
  handleInputChange: PropTypes.func.isRequired,
};

VoucherInput.defaultProps = {
  first4Digit: '',
  last4Digit: '',
  handleInputChange: () => { },
};
